import { render, staticRenderFns } from "./manage-pictograms.vue?vue&type=template&id=67f2dade&scoped=true"
import script from "./manage-pictograms.vue?vue&type=script&lang=js"
export * from "./manage-pictograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2dade",
  null
  
)

export default component.exports